
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexXadJwG_45E7tXvDp3rjybFgCVFNGElsiWPykRpnlfY80IMeta } from "/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_933v9Q4NR7yg6i2k1Dhg4oWFU9wPhF8W66CHWLn8oSm28Meta } from "/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue?macro=true";
import { default as index6GLrJX2C3HHAiYe6vLefGOk6K9Qp_452TDNXB3dM5qo2QMeta } from "/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue?macro=true";
import { default as _91slug_931WXCzwE3JMtfJTseYRO2Z1GOZbHEqrxIJEtWY1dqYWcMeta } from "/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue?macro=true";
import { default as _91slug_934t1tngNyQsJTevtZxhqasjb_ZKqsI7eVpVTsDIXnDukMeta } from "/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "index___ca/fr",
    path: "/ca/fr/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "index___ca/en",
    path: "/ca/en/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "index___qc/fr",
    path: "/qc/fr/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "index___qc/en",
    path: "/qc/en/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "index___intl/en",
    path: "/intl/en/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "index___intl/fr",
    path: "/intl/fr/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "index___us/en",
    path: "/us/en/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/index.vue")
  },
  {
    name: "slug___ca/fr",
    path: "/ca/fr/:slug(.*)*/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue")
  },
  {
    name: "slug___ca/en",
    path: "/ca/en/:slug(.*)*/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue")
  },
  {
    name: "slug___qc/fr",
    path: "/qc/fr/:slug(.*)*/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue")
  },
  {
    name: "slug___qc/en",
    path: "/qc/en/:slug(.*)*/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue")
  },
  {
    name: "slug___intl/en",
    path: "/intl/en/:slug(.*)*/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue")
  },
  {
    name: "slug___intl/fr",
    path: "/intl/fr/:slug(.*)*/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue")
  },
  {
    name: "slug___us/en",
    path: "/us/en/:slug(.*)*/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/[...slug].vue")
  },
  {
    name: "news___ca/fr",
    path: "/ca/fr/nouvelles/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue")
  },
  {
    name: "news___ca/en",
    path: "/ca/en/news/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue")
  },
  {
    name: "news___qc/fr",
    path: "/qc/fr/nouvelles/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue")
  },
  {
    name: "news___qc/en",
    path: "/qc/en/news/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue")
  },
  {
    name: "news___intl/en",
    path: "/intl/en/news/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue")
  },
  {
    name: "news___intl/fr",
    path: "/intl/fr/nouvelles/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue")
  },
  {
    name: "news___us/en",
    path: "/us/en/news/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/index.vue")
  },
  {
    name: "news-slug___ca/fr",
    path: "/ca/fr/nouvelles/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ca/en",
    path: "/ca/en/news/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue")
  },
  {
    name: "news-slug___qc/fr",
    path: "/qc/fr/nouvelles/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue")
  },
  {
    name: "news-slug___qc/en",
    path: "/qc/en/news/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue")
  },
  {
    name: "news-slug___intl/en",
    path: "/intl/en/news/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue")
  },
  {
    name: "news-slug___intl/fr",
    path: "/intl/fr/nouvelles/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue")
  },
  {
    name: "news-slug___us/en",
    path: "/us/en/news/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/news/[slug].vue")
  },
  {
    name: "our-brands-slug___ca/fr",
    path: "/ca/fr/nos-marques/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue")
  },
  {
    name: "our-brands-slug___ca/en",
    path: "/ca/en/our-brands/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue")
  },
  {
    name: "our-brands-slug___qc/fr",
    path: "/qc/fr/nos-marques/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue")
  },
  {
    name: "our-brands-slug___qc/en",
    path: "/qc/en/our-brands/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue")
  },
  {
    name: "our-brands-slug___intl/en",
    path: "/intl/en/our-brands/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue")
  },
  {
    name: "our-brands-slug___intl/fr",
    path: "/intl/fr/nos-marques/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue")
  },
  {
    name: "our-brands-slug___us/en",
    path: "/us/en/our-brands/:slug()/",
    component: () => import("/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/pages/our-brands/[slug].vue")
  }
]